import DFPAd from 'common/components/ad/dfp';
import StreamingNow from 'show-index/components/streaming-now';
import styles from './styles.less';
import VideoPlayer from 'common/components/video-player/asvp';
import { get } from 'lodash';
import { observer } from 'mobx-react';


@observer(['showsStore'])
class ShowIndexHeader extends React.Component {
    render() {
        return (
            <header className={ cx(styles.root, this.props.className) }>
                <div className={ styles.container }>
                    <DFPAd
                        className={ styles.ad }
                        id='ad_rect_atf_01'
                        type='rect'
                    />
                    <div className={ styles.videoPlayerContain }>
                        <VideoPlayer video={ this.props.showsStore.stream } />
                    </div>
                    <StreamingNow
                        className={ styles.streamingNow }
                        title={ get(this.props, 'showsStore.notification.title') }
                    />
                </div>
            </header>
        );
    }
}


export default ShowIndexHeader;



// WEBPACK FOOTER //
// ./src/show-index/containers/header/index.js